/* istanbul ignore next */
/* eslint-disable  no-underscore-dangle */

import $ from 'jquery';
import _ from 'underscore';
import ReactDOM from 'react-dom';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { Dialog } from '@bingads-webui/dialog';
import { withUiBlock } from '@bingads-webui/uiblocker';
import { gridOptionUtils } from '../hotel-center-service';
import {
  HotelGroupModel, SubAccountModel, lightDismissible,
} from '../hotel-center-shared';
import { SubAccountHotelGroupEditPanelView } from './subaccount-hotelgroup-edit-panel-view';
import EditControl from '../assignment-utils/edit-control';
import HotelViewBase from '../assignment-utils/hotel-view-base';
import template from './template-uinext.pug';

const i18n = globalContext.require('@bingads-webui/i18n-amd-loader!campaignui/feature/hotel-center');
const { DownloadViewV1 } = globalContext.require('campaignui/feature/griddownload/view/adapter');
const edm = globalContext.requireDefault('campaignui/feature/hotel-center-edm/index');
const jsdata = globalContext.require('campaignui/feature/hotel-center-js-data/index');
const state = globalContext.require('component/state/index');
const pageContext = globalContext.require('PageContext');
const permissions = pageContext && pageContext.Permissions;

lightDismissible();

const errorCodeToStringMap = {
  CreateFailed: i18n.getString('HotelCenter_Group_Create_Failed_Generic_Error_Message'),
  RenameFailed: i18n.getString('HotelCenter_Group_Rename_Failed_Generic_Error_Message'),
  DeleteFailed: i18n.getString('HotelCenter_Group_Delete_Failed_Generic_Error_Message'),
  SameValueAlreadyExist: i18n.getString('HotelCenter_Group_Name_Exists_Error_Message'),
  HotelGroupHasActiveAssociations: i18n.getString('HotelCenter_Group_Not_Empty_Delete_Error_Message'),
  GroupNotEmpty: i18n.getString('HotelCenter_Group_Not_Empty_Delete_Error_Message'),
  ValueTooLong: i18n.getString('Error_Campaign_API_ValueTooLong'),
  InternalError: i18n.getString('API_ErrorNumber_1011'),
};

const defaultSelection = {
  Id: 'selectAllSubAccount',
  Name: i18n.getString('HotelCenter_Subheader_All_SubAccount_Label'),
};

/**
 * Class representing hotel group list part for hotel center assignment
 * @extends View
 */
export default class HotelGroups extends HotelViewBase {
  /**
  * Initializes HotelGroups
  * @param {Object} options - input parameters
  * @returns {undefined}
  */
  initialize(options = {}) {
    this.options = options;
    this.i18n = i18n;
    this.HotelGroupModel = HotelGroupModel;
    this.hotelGroups = [];
    this.isSubAccountSelected = true;
    this.isHotelCenterDeprecation = permissions && permissions.dynamic.HotelCenterDeprecation;
    this.subAccountId = state.get('subAccount_id') || defaultSelection.Id;
    this.editPanel = new SubAccountHotelGroupEditPanelView({
      hotelGroups: this.hotelGroups,
      isSubAccountSelected: this.isSubAccountSelected,
      preSelectedKey: this.subAccountId,
      onSubAccountClick: item => this.onSubAccountClick(item),
      onHotelGroupClick: item => this.onHotelGroupClick(item),
      onCreateLinkClick: () => this.onCreateSubAccountLinkClick(),
      onRenameSubaccountSubmit: item => this.onSubAccountRename(item),
      onDeleteSubaccountSubmit: item => this.onSubAccountDelete(item),
      onRenameHotelGroupSubmit: item => this.onHotelGroupRename(item),
      onDeleteHotelGroupSubmit: item => this.onHotelGroupDelete(item),
      i18n,
    });

    this.fetchAssociations()
      .then((response) => {
        this.disableDownload(response.totalCount === 0);
      });

    this.refreshHotelGroups();
  }

  get events() {
    return {
      'click .create-button__container input': this.onShowCreateDialog,
      'click .associations-download__container input': this.onDownloadAssociations,
    };
  }

  get template() {
    return template;
  }

  renderTrunk() {
    super.renderTrunk();
  }

  renderEditPanel() {
    const editPanelElement = this.editPanel.render();
    const panelRoot = document.getElementById('subaccount-hotelgroup-edit-panel-root');

    ReactDOM.unmountComponentAtNode(panelRoot);
    ReactDOM.render(
      editPanelElement,
      panelRoot
    );
  }

  refreshHotelGroups({
    resetSelection = true,
    loadState = true,
    query = '',
  } = {}) {
    this.fetchHotelGroups(query)
      .then((hotelGroups) => {
        this.refreshTreeDataSource(hotelGroups);
        if (resetSelection) {
          if (!hotelGroups || hotelGroups.length <= 0) {
            this.trigger('noSubAccount');
          } else {
            this.setDefaultSelection(loadState);
          }
          this.renderEditPanel();
        }
      }).finally(withUiBlock($('#hotel-center-assignment')));
  }

  refreshTreeDataSource(newHotelGroups) {
    this.hotelGroups.length = 0;
    _.each(newHotelGroups, item => this.hotelGroups.push(item));
  }

  getFirstSubaccount(hotelGroups) {
    const ungroup = _.find(
      hotelGroups,
      item => item.Name === 'Ungrouped'
    );

    return {
      SubAccount: {
        Id: ungroup.SubAccountId,
        Name: ungroup.SubAccountName,
      },
      Ungroup: {
        Id: ungroup.Id,
        Name: ungroup.Name,
        HotelAssociationCount: ungroup.HotelAssociationCount,
      },
    };
  }

  getSubaccountById(hotelGroups, subAccountId) {
    const group = _.find(
      hotelGroups,
      item => item.SubAccountId === subAccountId && item.Name === 'Ungrouped'
    );

    return group ? {
      Id: group.SubAccountId,
      Name: group.SubAccountName,
      UngroupId: group.Id,
      UngroupName: group.Name,
      HotelAssociationCount: group.HotelAssociationCount,
    } : null;
  }

  fetchAssociations() {
    const odataOptions = {
      cacheResponse: false,
      url: gridOptionUtils.getUrlByName('associations'),
    };

    return jsdata.HotelAssociation.findAll({}, odataOptions);
  }

  fetchHotelGroups(query = '') {
    const entitySet = edm.currentAccount.HotelGroups;
    const select = 'Id,Name,SubAccountName,SubAccountId,HotelAssociationCount';
    // if no $top limit passed in, a default $top=20 will be appended to query
    // so we passed the limit for MT allowed max
    // if exceed, an 400 error will return with code: InvalidQuery
    // and error message: The limit of '5000' for Top query has been exceeded
    const max = 5000;
    const queryOption = {
      $select: select,
      $top: max,
    };

    if (!_.isEmpty(query)) {
      queryOption.$filter = `contains(Name,'${query}')`;
    }

    return jsdata.HotelGroup.findAll({
      query: queryOption,
    }, {
      entitySet,
      cacheResponse: false,
    });
  }

  disableDownload(disabled) {
    const hasDisabled = this.$('.associations-download__container .btn').hasClass('disabled');

    if (!hasDisabled && disabled) {
      this.$('.associations-download__container .btn').addClass('disabled');
    } else if (hasDisabled && !disabled) {
      this.$('.associations-download__container .btn').removeClass('disabled');
    }
  }

  onDownloadAssociations() {
    this.fetchAssociations()
      .then((response) => {
        if (response.totalCount === 0) {
          this.disableDownload(true);
          this._showError(i18n.getString('HotelCenter_Group_Has_No_Association_Error_Message'));
          return;
        }
        const localizedHeaders = [
          i18n.getString('HotelCenter_Overview_Grid_Hotel_Advertiser_Hotel_ID_Label'),
          i18n.getString('HotelCenter_Group_Hotel_Name_Label'),
          i18n.getString('HotelCenter_Group_Name_Label'),
          i18n.getString('HotelCenter_Overview_Grid_Shared_SubAccount_Name_Label'),
        ];
        const odataColumnNames = ['PartnerHotelId', 'HotelName', 'HotelGroupName', 'SubAccountName'];
        const downloadView = new DownloadViewV1({
          localizedHeaders,
          odataColumnNames,
          filterUrlParam: '',
          segmentationTypes: [],
          entity: 'HotelAssociation',
          gridId: 'HotelGroupAssociationsDownloadGrid',
          totalRecordCount: response.totalCount,
          processReportRule: ReportRule => _.defaults({
            Selection: _.defaults({
              CampaignId: Number(this.selectedSubAccount.Id),
            }, ReportRule.Selection),
          }, ReportRule),
        });

        downloadView.download();
        downloadView.remove();
      });
  }

  onShowCreateDialog() {
    const entitySet = edm.currentAccount
      .SubAccounts.$withKey(this.selectedSubAccount.Id)
      .HotelGroups;
    const hotelGroupModel = new HotelGroupModel({ entitySet });

    const hotelNameInput = new EditControl({
      entity: hotelGroupModel,
      field: 'Name',
      description: i18n.getString('HotelCenter_Group_Create_Description'),
    });

    hotelGroupModel.errors.on('change:Name', (vm, error) => {
      if (_.isEmpty(error)) {
        $('.hotel-center-group-dialog-save').removeClass('disabled');
      } else {
        $('.hotel-center-group-dialog-save').addClass('disabled');
      }
    });

    const dialog = new Dialog({ className: 'hotel-center-group-dialog' }).setContent(hotelNameInput).setState({
      title: i18n.getString('HotelCenter_Group_Create_Title', this.getState().groupName),
      buttons: [{
        text: i18n.getString('HotelCenter_Shared_Create'),
        name: 'confirm',
        class: 'hotel-center-group-dialog-save',
      }, {
        text: i18n.getString('HotelCenter_Shared_Cancel'),
        name: 'cancel',
        class: 'dialog-cancel',
      }],
    });

    document.body.appendChild(dialog.el);
    dialog.show();
    $('.hotel-center-group-dialog-save').addClass('disabled');
    $('.hotel-center-group-dialog .close').focus();

    dialog.on('clickedButton', (name) => {
      const isbuttonDisabled = $('.hotel-center-group-dialog-save').hasClass('disabled');
      if (name === 'confirm') {
        if (!isbuttonDisabled) {
          this._createHotelGroupAsync(hotelGroupModel).then((isSuccess) => {
            if (isSuccess) {
              dialog.remove();
              $('.create-hotel-group-button').focus();
            } else {
              $('.hotel-center-group-dialog-save').addClass('disabled');
            }
          });
        }
      } else {
        dialog.remove();
        $('.create-hotel-group-button').focus();
      }
    });
  }

  _createHotelGroupAsync(hotelGroupModel) {
    return hotelGroupModel
      .save()
      .then(() => {
        this.refreshHotelGroups({ resetSelection: false, loadState: false });
        this._showInfo(i18n.getString('Page_Pricing_ChangesSaved'));
        return true;
      })
      .catch((e) => {
        let errorCode = 'CreateFailed';

        if (e && e.body && e.body.value && e.body.value.length > 0) {
          errorCode = e.body.value[0].Code;
        }

        this._handleModelError(errorCode, hotelGroupModel);

        return false;
      });
  }

  _handleModelError(errorCode, model) {
    const errorMsg = errorCodeToStringMap[errorCode];

    // Error is expecting an array to be set.
    model.errors.set('Name', [errorMsg]);
    this._showError(errorMsg);
  }

  _showError(message) {
    const { alertCenter } = window.App.views;

    if (alertCenter && _.isFunction(alertCenter.showError)) {
      alertCenter.showError(message);
    }
  }

  _showInfo(message) {
    const { alertCenter } = window.App.views;

    if (alertCenter && _.isFunction(alertCenter.showInfo)) {
      alertCenter.showInfo(message);
    }
  }

  getHotelGroupModel(subAccountId, groupId) {
    const entitySet = edm.currentAccount
      .SubAccounts.$withKey(subAccountId.toString())
      .HotelGroups;

    return new HotelGroupModel({
      Id: groupId,
      entitySet,
    });
  }

  getSubAccountModel(subAccountId) {
    const entitySet = edm.currentAccount.SubAccounts;

    return new SubAccountModel({
      Id: subAccountId,
      entitySet,
    });
  }

  _UpdateNameAsync(model) {
    return model
      .save(['Name'], { patch: true })
      .then(() => {
        const updatedName = model.attributes.Name;

        return {
          isSuccess: true,
          updatedName,
        };
      })
      .catch((e) => {
        this.trigger('error', e);

        let errorCode = 'RenameFailed';

        if (e.body && e.body.value && e.body.value.length > 0) {
          errorCode = e.body.value[0].Code;
        }

        this._handleModelError(errorCode, model);
        this.refreshHotelGroups();

        return {
          isSuccess: false,
          updatedName: '',
        };
      }).finally(() => {
        // TODO
      });
  }

  _deleteCurrentGroupAsync(model) {
    return model.destroy()
      .then(() => ({
        isSuccess: true,
      }))
      .catch((e) => {
        this.trigger('error', e);

        let errorCode = 'DeleteFailed';

        if (e.body && e.body.value && e.body.value.length > 0) {
          errorCode = e.body.value[0].Code;
        }

        this._handleModelError(errorCode, model);

        return {
          isSuccess: false,
          errorCode,
        };
      }).finally(() => {
        // TODO
      });
  }

  setDefaultSelection(loadState = true) {
    const defaultSubAccount = this.getFirstSubaccount(this.hotelGroups);
    const stateSubAccountId = state.get('subAccount_id');
    const subAccount = !_.isEmpty(stateSubAccountId) ?
      this.getSubaccountById(this.hotelGroups, this.subAccountId) :
      null;

    this.isSubAccountSelected = true;

    if (loadState && !_.isEmpty(stateSubAccountId) && subAccount) {
      this.subAccountId = subAccount.Id;
      this.selectedSubAccount = {
        Id: subAccount.Id,
        Name: subAccount.Name,
      };
      this.selectedGroup = {
        Id: subAccount.UngroupId,
        Name: subAccount.UngroupName,
        ParentId: subAccount.Id,
        SubAccountId: subAccount.Id,
        SubAccountName: subAccount.Name,
        HotelAssociationCount: subAccount.HotelAssociationCount,
      };
    } else {
      this.subAccountId = defaultSubAccount.Id;
      this.selectedSubAccount = {
        Id: defaultSubAccount.SubAccount.Id,
        Name: defaultSubAccount.SubAccount.Name,
        ParentId: 0,
        childrenKeys: [],
      };
      this.selectedGroup = {
        Id: defaultSubAccount.Ungroup.Id,
        Name: defaultSubAccount.Ungroup.Name,
        ParentId: defaultSubAccount.SubAccount.Id,
        SubAccountId: defaultSubAccount.SubAccount.Id,
        SubAccountName: defaultSubAccount.SubAccount.Name,
        HotelAssociationCount: defaultSubAccount.Ungroup.HotelAssociationCount,
      };
    }
    state.set('subAccount_id', '');

    this.trigger('selectionChanged', {
      selectedGroup: this.selectedGroup,
      selectedSubAccount: this.selectedSubAccount,
      isSubAccountSelected: true,
      ungroupedGroupId: this.selectedGroup.Id,
    });
  }

  onSubAccountClick(subaccount) {
    if (this.hotelGroups.length <= 0) {
      this.subAccountId = '';
      this.trigger('noSubAccount');
      return;
    }

    if (subaccount.Id === 'selectAllSubAccount') {
      this.setDefaultSelection();
      return;
    }

    this.isSubAccountSelected = true;
    this.subAccountId = subaccount.Id;
    this.selectedGroup = {
      Id: subaccount.SelectedGroupId,
      Name: subaccount.SelectedGroupName,
      ParentId: subaccount.Id,
      SubAccountId: subaccount.Id,
      SubAccountName: subaccount.Name,
      HotelAssociationCount: subaccount.SelectedGroupAssociationCount,
    };
    this.selectedSubAccount = {
      Id: subaccount.Id,
      Name: subaccount.Name,
      ParentId: 0,
      childrenKeys: subaccount.ChildrenKeys,
    };

    state.set('subAccount_id', subaccount.Id);

    this.trigger('selectionChanged', {
      selectedGroup: this.selectedGroup,
      selectedSubAccount: this.selectedSubAccount,
      isSubAccountSelected: true,
      ungroupedGroupId: subaccount.UngroupChildId,
    });
    this.fetchAssociations().then((response) => {
      this.disableDownload(response.totalCount === 0);
    });
  }

  onHotelGroupClick(hotelGroup) {
    this.isSubAccountSelected = false;
    this.subAccountId = hotelGroup.ParentId;
    this.selectedGroup = {
      Id: hotelGroup.Id,
      Name: hotelGroup.Name,
      ParentId: hotelGroup.ParentId,
    };
    this.selectedSubAccount = {
      Id: hotelGroup.ParentId,
      childrenKeys: hotelGroup.SiblingKeys,
    };

    state.set('subAccount_id', hotelGroup.ParentId);

    this.trigger('selectionChanged', {
      selectedGroup: this.selectedGroup,
      selectedSubAccount: this.selectedSubAccount,
      isSubAccountSelected: false,
      ungroupedGroupId: hotelGroup.SiblingUngroup,
    });
  }

  onCreateSubAccountLinkClick() {
    if (this.options && this.options.router && _.isFunction(this.options.router.navigateToSetup)) {
      this.options.router.navigateToSetup();
    }
  }

  onSubAccountRename(subAccount) {
    const model = this.getSubAccountModel(subAccount.Id);
    model.set('Name', subAccount.NewName);
    this._UpdateNameAsync(model).bind(this).then(({ isSuccess }) => {
      if (isSuccess) {
        this.refreshHotelGroups({ resetSelection: false, loadState: false });
        this.isSubAccountSelected = true;
        this.selectedSubAccount.Name = subAccount.NewName;
        this.trigger('selectionChanged', {
          selectedGroup: this.selectedGroup,
          selectedSubAccount: this.selectedSubAccount,
          isSubAccountSelected: true,
        });
      }
    });
  }

  onSubAccountDelete(subAccount) {
    const model = this.getSubAccountModel(subAccount.Id);
    this._deleteCurrentGroupAsync(model).bind(this).then(({ isSuccess }) => {
      if (isSuccess) {
        this.refreshHotelGroups();
      }
    });
  }

  onHotelGroupRename(hotelGroup) {
    const model = this.getHotelGroupModel(this.selectedSubAccount.Id, hotelGroup.Id);
    model.set('Name', hotelGroup.NewName);
    this._UpdateNameAsync(model).bind(this).then(({ isSuccess }) => {
      if (isSuccess) {
        this.refreshHotelGroups({ resetSelection: false, loadState: false });
        this.isSubAccountSelected = false;
        this.selectedGroup.Name = hotelGroup.NewName;
        this.trigger('selectionChanged', {
          selectedGroup: this.selectedGroup,
          selectedSubAccount: this.selectedSubAccount,
          isSubAccountSelected: false,
        });
      }
    });
  }

  onHotelGroupDelete(hotelGroup) {
    const model = this.getHotelGroupModel(this.selectedSubAccount.Id, hotelGroup.Id);
    this._deleteCurrentGroupAsync(model).bind(this).then(({ isSuccess }) => {
      if (isSuccess) {
        this.refreshHotelGroups();
      }
    });
  }
}
